import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, del, post } from '../api/client.js';

// My own sessions — listed under /profile or /admin/sessions for everyone.
export function useMySessions() {
  return useQuery({
    queryKey: ['me', 'sessions'],
    queryFn: async () => (await get('/api/me/sessions')).sessions || [],
    staleTime: 15_000,
  });
}

export function useRevokeMySession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (token) => {
      // No DELETE-with-body helper in api/client — go via raw fetch.
      const res = await fetch('/api/me/sessions', {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      if (!res.ok) throw new Error((await res.json()).error || 'Failed');
      return res.json();
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['me', 'sessions'] }),
  });
}

// Admin: every active session across the org.
export function useAllSessions() {
  return useQuery({
    queryKey: ['admin', 'sessions'],
    queryFn: async () => (await get('/api/admin/sessions')).sessions || [],
    staleTime: 10_000,
  });
}

export function useAdminRevokeSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (token) => del(`/api/admin/sessions/${token}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'sessions'] }),
  });
}
